import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, err, money, when } from "../../lib/api";

function BalanceForm({ onDone }) {
  const [f, setF] = useState({ phone: "", type: "credit", amount: "", reason: "" }), [busy, setBusy] = useState(false);
  const set = k => e => setF({ ...f, [k]: e.target.value });
  const send = async () => {
    setBusy(true);
    try {
      const r = await api.post(`/admin/users/${f.phone.trim()}/balance`, { type: f.type, amount: Number(f.amount), reason: f.reason });
      toast.success(`${f.type === "credit" ? "Added" : "Deducted"} ${money(f.amount)} · New balance ${money(r.data.balance)}`);
      setF({ ...f, amount: "", reason: "" }); onDone();
    } catch (e) { toast.error(err(e)); }
    setBusy(false);
  };
  return (
    <section className="admin-section" data-testid="balance-adjust-form"><h2>Send / deduct balance</h2>
      <div className="admin-form">
        <label>User phone number<input value={f.phone} onChange={set("phone")} placeholder="e.g. 98xxxxxxxx" data-testid="adjust-phone-input" /></label>
        <label>Action<select value={f.type} onChange={set("type")} data-testid="adjust-type-select"><option value="credit">Send (add) balance</option><option value="debit">Deduct balance</option></select></label>
        <label>Amount ₹<input type="number" value={f.amount} onChange={set("amount")} data-testid="adjust-amount-input" /></label>
        <label>Reason<input value={f.reason} onChange={set("reason")} placeholder="Reason shown to user" data-testid="adjust-reason-input" /></label>
        <div className="full"><button className={`btn ${f.type === "credit" ? "green" : "red"}`} disabled={busy || !f.phone || !f.amount || f.reason.length < 2} onClick={send} data-testid="adjust-submit-button">{f.type === "credit" ? "Send balance" : "Deduct balance"}</button></div>
      </div>
    </section>
  );
}

export default function AdminUsers() {
  const [q, setQ] = useState(""), [users, setUsers] = useState([]);
  const load = useCallback(() => api.get("/admin/users", { params: { q } }).then(r => setUsers(r.data)), [q]);
  useEffect(() => { const t = setTimeout(load, 300); return () => clearTimeout(t); }, [load]);
  const toggle = async u => {
    try { await api.patch(`/admin/users/${u.phone}/status`, { status: u.status === "active" ? "suspended" : "active" }); toast.success("User updated"); load(); } catch (e) { toast.error(err(e)); }
  };
  return (
    <>
      <BalanceForm onDone={load} />
      <section className="admin-section">
        <div className="section-head"><h2>User management</h2><span className="report-note">{users.length} users</span></div>
        <div className="filter-bar"><input className="admin-input" value={q} onChange={e => setQ(e.target.value)} placeholder="Search phone or name" data-testid="admin-user-search" /></div>
        <div className="table-wrap"><table className="admin-table"><thead><tr><th>User</th><th>Balance</th><th>Wagered</th><th>Status</th><th /></tr></thead><tbody>
          {users.map(u => <tr key={u.id} data-testid={`admin-user-${u.phone}`}><td><b>{u.phone}</b><small>{u.name} · joined {when(u.created_at)}</small></td><td>{money(u.balance)}</td><td>{money(u.wagered)}</td>
            <td><span className={`status ${u.status}`}>{u.status}</span></td>
            <td><button className={`btn ${u.status === "active" ? "red" : "green"}`} onClick={() => toggle(u)} data-testid={`toggle-user-${u.phone}`}>{u.status === "active" ? "Suspend" : "Activate"}</button></td></tr>)}
        </tbody></table></div>
      </section>
    </>
  );
}
